//Carga los módulos de los listados genéricos de noticias
import {initTopBottom} from "../modulos/topbottom/topbottom";
import analisisMasVistos from "../modulos/analisisMasVistos/analisisMasVistos";
import {infiniteScrollDetect} from "../modulos/infiniteScrolling/detectAndLoadInfiniteScrolling";
import Streaming from "../streaming/streaming";

export const loadList = () => {
    console.log('Loading list components');

    //Inicializa los módulos de top/flops
    initTopBottom(Streaming);

    //Módulo de análisis más vistos
    analisisMasVistos();

    //Scrolls infinitos
    infiniteScrollDetect();
}
